import React, { useState } from 'react';
import { toast } from 'sonner';
import { BellRing, Send, Video } from 'lucide-react';
import api from '@/utils/api';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const errText = (e) => { const d = e?.response?.data?.detail; return typeof d === 'string' ? d : 'Erro'; };
const fmt = (v) => (v ? new Date(v).toLocaleString('pt-PT', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '');

// «Entrar na reunião»: abre o Zoom e avisa a empresa «Já estamos na reunião» (1 vez); «Avisar outra vez» reenvia.
export const JoinMeetingButtons = ({ r, onChange }) => {
  const [busy, setBusy] = useState(false);
  const notify = async (resend) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/prospects/${r.id}/meeting/joined`, { resend });
      if (data.sent) toast.success('Empresa avisada: «Já estamos na reunião»');
      onChange?.();
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  return <>
    <Button asChild size="sm" className="bg-blue-700 hover:bg-blue-800">
      <a href={r.link} target="_blank" rel="noopener noreferrer" onClick={() => notify(false)} data-testid={`agenda-join-${r.id}`}><Video className="h-4 w-4 mr-1" />Entrar na reunião</a>
    </Button>
    {r.joined_notice_at && <Button size="sm" variant="outline" disabled={busy} onClick={() => notify(true)} data-testid={`agenda-join-resend-${r.id}`}>
      <BellRing className="h-4 w-4 mr-1" />Avisar outra vez
    </Button>}
  </>;
};

// Envio manual: mostra o email antes de enviar; a empresa confirma numa página com botão «Confirmar» (POST).
export const RequestConfirmationButton = ({ r, onChange }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/admin/prospects/${r.id}/meeting/request-confirmation`); toast.success(`Pedido enviado para ${data.sent_to}`); setOpen(false); onChange?.(); }
    catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  return <>
    <Button size="sm" className="bg-orange-600 hover:bg-orange-700 text-white" disabled={!r.email} onClick={() => setOpen(true)} data-testid={`agenda-request-confirm-${r.id}`}>
      <Send className="h-4 w-4 mr-1" />{r.confirmation_requested_at ? 'Pedir confirmação outra vez' : 'Pedir confirmação'}
    </Button>
    {r.confirmation_requested_at && <span className="text-xs text-slate-500 self-center" data-testid={`agenda-request-sent-${r.id}`}>Pedido enviado {fmt(r.confirmation_requested_at)}</span>}
    {open && <Dialog open onOpenChange={(o) => !o && !busy && setOpen(false)}>
      <DialogContent className="max-w-md" data-testid="request-confirm-dialog">
        <DialogHeader><DialogTitle>Pedir confirmação a {r.company}</DialogTitle><DialogDescription>Para: {r.email}</DialogDescription></DialogHeader>
        <p className="text-sm text-slate-700">Email curto e educado com o horário <strong>{r.date_label} às {r.time_cv} (hora de Cabo Verde)</strong> e o botão «Confirmar a reunião». A reunião só volta a «Confirmada» quando alguém clicar mesmo em «Confirmar».</p>
        <DialogFooter className="gap-2">
          <Button variant="outline" disabled={busy} onClick={() => setOpen(false)} data-testid="request-confirm-cancel">Cancelar</Button>
          <Button disabled={busy} onClick={send} data-testid="request-confirm-send">{busy ? 'A enviar…' : 'Enviar'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>}
  </>;
};
